import React from "react";
import SearchField from "../../../components/ui/SearchField";

interface TableSearchProps {
  value: string;
  onChange: (value: string) => void;
}

const TableSearch: React.FC<TableSearchProps> = ({ value, onChange }) => {
  return <SearchField className="w-80" placeholder="Search" value={value} onChange={onChange} />;
};

export default TableSearch;
